import { Link } from "react-router-dom"
import {
  buildChangeLanguageUrl,
  buildLoginUrl,
  buildLogoutUrl,
  hasText,
} from "utils/helpers"
import { useMessages } from "../language/language"
import { TopNavLinks } from "../components/top-nav"
import { connectionClosedReducer } from "play/reducers"
import { SyntheticEvent } from "react"
import { setGlobalDontPreventBrowserClose } from "play/play-model"
import { usePlayState } from "play/hooks/use-play-state"

export default function DefaultTopNavLinks(props: {}) {
  const { loggedUser, connectionId, modifyState } = usePlayState()
  const loggedUserId = loggedUser?.id
  //const loggedUserIsStudent = loggedUser?.isStudent === true
  const loggedUserIsTeacher = loggedUser?.isTeacher === true
  const isGameRunning = hasText(connectionId)

  const isLoggedIn = !!loggedUserId
  const msg = useMessages()
  const changeLangLocale = buildChangeLanguageUrl()
  const otherLocale = msg.locale_code === "bg" ? "en" : "bg"

  function handleExitGame(e: SyntheticEvent) {
    e.preventDefault()
    setGlobalDontPreventBrowserClose(true)
    modifyState((state) => {
      connectionClosedReducer(state)
    })
  }

  return (
    <TopNavLinks>
      <a className={`flag ${otherLocale}`} href={changeLangLocale}></a>
      {isLoggedIn ? (
        <>
          {isGameRunning ? (
            <a href="#" onClick={handleExitGame}>
              {msg.studentScreenFrame_quitGame}
            </a>
          ) : (
            <>
              <Link to="/profile">{msg.pageTitleProfile}</Link>
              <Link to="/history">{msg.studentScreenFrame_history}</Link>
              <Link to="/certificates">{msg.pageTitleCertificates}</Link>
              {loggedUserIsTeacher && (
                <a href={`/${msg.locale_code}/admin`}>{msg.menuAdmin}</a>
              )}
            </>
          )}
          <a href={buildLogoutUrl()}>{msg.loginPage_logOut}</a>
        </>
      ) : (
        <>
          {isGameRunning && (
            <a href="#" onClick={handleExitGame}>
              {msg.studentScreenFrame_quitGame}
            </a>
          )}
          <a href={buildLoginUrl()}>{msg.loginPage_logIn}</a>
        </>
      )}
    </TopNavLinks>
  )
}
